export default "__VITE_ASSET__DYOzgxg8__"